export const PROSPECTS_PER_PAGE = 20;
